import type { editor } from 'monaco-editor';
import type { IQueryFieldsItem } from 'src/interfaces/entities/observer';
import * as monaco from 'monaco-editor';

export const editorOptions: editor.IEditorConstructionOptions = {
	renderLineHighlight: 'none',
	glyphMargin: false,
	lineNumbersMinChars: 0,
	overviewRulerBorder: false,
	overviewRulerLanes: 0,
	wordWrap: 'on',
	scrollBeyondLastLine: false,
	minimap: {
		enabled: false,
	},
	scrollbar: {
		horizontal: 'auto',
		vertical: 'auto',
		alwaysConsumeMouseWheel: false,
	},
};

export const generateKeyDocs = (
	sqlQuery?: IQueryFieldsItem[]
): { property: string; docs: monaco.IMarkdownString }[] => {
	return [
		{
			property: 'occurence',
			docs: {
				value: 'Objeto representando a ocorrência.',
			},
		},
		{
			property: 'observer',
			docs: {
				value: 'Objeto representando o observador.',
			},
		},
		{
			property: 'occurence.affectedRows',
			docs: {
				value: `Objeto representando as linhas afetadas.`,
			},
		},
		{
			property: 'occurence.affectedRows.result',
			docs: {
				value: `Array de objetos representando as linhas afetadas.
                Cada objeto contém os campos afetados.
                
                - Propriedades diponíveis:
                ${sqlQuery?.map((item) => item.field).join(', ')}`,
			},
		},
		{
			property: 'occurence.affectedRows.count',
			docs: {
				value: `Número de linhas afetadas.`,
			},
		},
		{
			property: 'occurence.affectedFields',
			docs: {
				value: `Objeto representando os campos afetados.`,
			},
		},
		{
			property: 'occurence.affectedFields.result',
			docs: {
				value: `Array de strings representando os campos afetados.
                  Exemplo:
                [${sqlQuery?.map((item) => item.field).join(', ')}]`,
			},
		},
		{
			property: 'occurence.affectedFields.count',
			docs: {
				value: `Número de campos afetados.`,
			},
		},
		{
			property: 'occurence.meta',
			docs: {
				value: `Objeto representando os metadados da ocorrência.`,
			},
		},
		{
			property: 'occurence.meta.executionMS',
			docs: {
				value: `Tempo de execução da query em milissegundos.`,
			},
		},
		{
			property: 'occurence.meta.totalRowsCount',
			docs: {
				value: `Número total de linhas da ocorrência.`,
			},
		},
		{
			property: 'occurence.meta.executionDate',
			docs: {
				value: `Data de execução da ocorrência.`,
			},
		},
		{
			property: 'observer.observerId',
			docs: {
				value: `ID do observador.`,
			},
		},
		{
			property: 'observer.name',
			docs: {
				value: `Nome do observador.`,
			},
		},
		{
			property: 'severity.name',
			docs: {
				value: `Nome da severidade da ocorrência.`,
			},
		},

	];
};